import {
  ParentAllGroupingRule,
  PerspectiveGroupingRule,
} from '@ardoq/perspectives';
import { type I18nLocale, t } from '@ardoq/i18n';
import { RowHeader } from '../../atoms';
import {
  GroupNameHeaderInfoIcon,
  ParentAllGroupRule as PerspectiveParentAllGroupRule,
} from '@ardoq/perspectives';

type ParentAllGroupRuleProps = {
  groupingRule: ParentAllGroupingRule;
  onGroupingRuleUpdated: (
    groupingRuleId: string,
    updatedGroupingRule: Partial<PerspectiveGroupingRule>
  ) => void;
  tabIndex?: number;
  i18nLocale: I18nLocale;
};

const ParentAllGroupRule = ({
  i18nLocale,
  ...props
}: ParentAllGroupRuleProps) => {
  return (
    <PerspectiveParentAllGroupRule
      {...props}
      i18nLocale={i18nLocale}
      ruleHeader={
        <RowHeader>
          {t(
            i18nLocale,
            'perspectivesSidebar:groupingRules.groupName',
            'Group name'
          )}
          <GroupNameHeaderInfoIcon />
        </RowHeader>
      }
    />
  );
};

export { ParentAllGroupRule };
